<template>
	<div class="login-container">
		<div class="top_shade">
			<div class="logo">
				<div class="flex align-center justify-center">
					<img src="../../assets/img/logo@2x.png" alt="">
				</div>
				<div class="logo_text">
					网络会议
				</div>
			</div>
			<div class="official_website">
				<el-popover
					placement="bottom-end"
					trigger="hover"
					popper-class="wechat-qrcode-popover">
					<div class="wechat-qrcode-wrap">
						<img src="../../assets/img/qrcode.png" alt="微信公众号二维码" class="wechat-qrcode-img" />
					</div>
					<div slot="reference" class="wechat-trigger">
						<img src="../../assets/img/bf_qrcode.png" alt="微信公众号" class="wechat-icon" />
					</div>
				</el-popover>
			</div>
		</div>

		<div class="login-wrap">
			<div class="flex align-center justify-center login-wrap_text">
				<div class="">
					<div class="login-wrap_text1">
						让会议更高效
					</div>
					<div class="login-wrap_text2">
						Make meetings more efficient
					</div>
				</div>
			</div>
			<div class="ms-login" >
				<!-- <div class="ms-title">网络会议</div> -->
				<div class="flex align-center justify-center" style="width: 100%;">
					<div class="flex align-center" style="margin-top: 40px;">
						<div class="flex align-center justify-center login_text_img">
							<img src="../../assets/img/logocai@2x.png" alt="">
						</div>
						<div class="ms-login_text" style="margin-left: 20px;">
							破产云网络会议
						</div>
					</div>
				</div>
				<div class="" style="display: flex;align-items: center;justify-content: center;width: 100%;">
					<div class="" style="width: 90%;border-bottom: 1px solid #e6e6e6;display: flex;align-items: center;justify-content: center;font-size: 24px;">
						<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" text-color="#BBBBBB" >
						  <el-menu-item index="1">账号</el-menu-item>
						  <el-menu-item index="2">短信</el-menu-item>
						</el-menu>
					</div>
				</div>
				<div v-if="activeIndex == '1'" class="" style="width: 100%;position: relative;">
					<el-form :model="params" :rules="rules" ref="login" label-width="70px" class="ms-content"
						label-position="left">
						<!-- label="账号" -->
						<el-form-item prop="username" label-width="0">
							<!-- prefix-icon="el-icon-zhanghu" -->
							<el-input  size="medium" v-model="params.username" placeholder="请输入账号" >
								<div slot="prefix"  class="flex align-center justify-center" style="width: 30px;height: 45px;">
									<img style="width: 20px;height: 18px;" src="../../assets/img/userID@2x.png" alt="">
								</div>
							
							</el-input>
						</el-form-item>
						<!-- label="密码" -->
						<el-form-item prop="password" label-width="0">
							<template slot-scope="scope">
								<!-- prefix-icon="el-icon-mima" -->
								<el-input v-if="passwordType" size="medium"  type="text" placeholder="请输入密码"
									v-model="params.password" @keyup.enter.native="submitForm()">
									<img @click="passwordType = false" v-if="passwordType" style="width: 22px;height: 22px;margin-top: 12px;margin-right: 5px;" slot="suffix" src="../../assets/img/invisible.png" alt="">
									<div slot="prefix" class="flex align-center justify-center" style="width: 30px;height: 45px;">
										<img style="width: 21px;height: 19px;" src="../../assets/img/password@2x.png" alt="">
									</div>
									
								</el-input>
								<!-- prefix-icon="el-icon-mima" -->
								<el-input v-else  size="medium" type="password" placeholder="请输入密码"
									v-model="params.password" @keyup.enter.native="submitForm()">
									<img @click="passwordType = true" v-if="!passwordType" style="width: 22px;height: 22px;margin-top: 12px;margin-right: 5px;" slot="suffix" src="../../assets/img/visible.png" alt="">
									<div slot="prefix" class="flex align-center justify-center" style="width: 30px;height: 45px;">
										<img style="width: 21px;height: 19px;" src="../../assets/img/password@2x.png" alt="">
									</div>
									
								</el-input>
							</template>
						</el-form-item>
						<!-- label="验证码" -->
						<el-form-item prop="captchaCode" label-width="0">
							<!-- prefix-icon="el-icon-yanzhengma"  -->
							<el-input size="medium" placeholder="请输入验证码" v-model="params.captchaCode"
								@keyup.enter.native="submitForm" style="width: 71%; margin-right: 10px;" >
								<div slot="prefix" class="flex align-center justify-center" style="width: 30px;height: 45px;">
									<img style="width: 19px;height: 19px;" src="../../assets/img/验证码@2x.png" alt="">
								</div>
								
								</el-input>
							<img style="border: 1px solid rgba(0,0,0,0.1);border-radius: 4px;" :src="imgUrl" alt="" @click="randomLenNum" title="点击切换图片" />
						</el-form-item>
						<!-- 记住密码 -->
						<el-form-item label-width="0">
							<el-checkbox style="margin-top: -15px;" v-model="checked">记住密码</el-checkbox>
						</el-form-item>
						<div class="login-btn" style="position: absolute;bottom: -25px;width: 86%;">
							<el-button style="margin-top: -20px;" type="primary" @click="submitForm" :loading="loading"
								:disabled="disabled">登录
							</el-button>
						</div>
						<!-- <div style="display: flex; align-items: center; justify-content: center; margin-top: 20px">
							<a href="http://www.shicanxinxi.cn/" target="_blank">
								<el-button round>跳转官网</el-button>
							</a>
						</div> -->
						<div class="login-bottom">
							<!-- <a href="javascript:;" title="常见问题">常见问题</a> -->
							<!--  <i class="iconfont icon-shuxian"></i>
					    <a href="javascript:;" title="忘记密码">忘记密码?</a> -->
						</div>
					</el-form>
				</div>
				<div v-if="activeIndex == '2'" class="" style="width: 100%;position: relative;height: 282px;">
					<el-form :model="params" :rules="rules" ref="login" label-width="70px" class="ms-content"
						label-position="left">
						<!-- label="账号" -->
						<el-form-item prop="phone" label-width="0">
							<!-- prefix-icon="el-icon-zhanghu" -->
							<el-input  size="medium" v-model="params.phone" placeholder="请输入手机号码" >
								<div slot="prefix"  class="flex align-center justify-center" style="width: 30px;height: 45px;">
									<img style="width: 20px;height: 18px;" src="../../assets/img/phone.png" alt="">
								</div>
							</el-input>
						</el-form-item>
						<!-- label="验证码" -->
						<el-form-item prop="captchaCode" label-width="0">
							<!-- prefix-icon="el-icon-yanzhengma"  -->
							<el-input size="medium" placeholder="请输入验证码" v-model="params.captchaCode"
								@keyup.enter.native="submitForm" style="width: 71%; margin-right: 10px;" >
								<div slot="prefix" class="flex align-center justify-center" style="width: 30px;height: 45px;">
									<img style="width: 19px;height: 19px;" src="../../assets/img/验证码@2x.png" alt="">
								</div>
								</el-input>
								<el-button @click="tapGetCode" style="height: 45px;width: 150px;"
									type="primary" plain>
									{{codeTime=='0'?'获取验证码':codeTime+'秒后获取'}}
								</el-button>
							<!-- <img style="border: 1px solid rgba(0,0,0,0.1);border-radius: 4px;" :src="imgUrl" alt="" @click="randomLenNum" title="点击切换图片" /> -->
						</el-form-item>
						<div class="login-btn" style="position: absolute;bottom: -25px;width: 86%;">
							<el-button style="" type="primary" @click="submitForm" :loading="loading"
								:disabled="disabled">登录
							</el-button>
						</div>
						<!-- <div style="display: flex; align-items: center; justify-content: center; margin-top: 20px">
							<a href="http://www.shicanxinxi.cn/" target="_blank">
								<el-button round>跳转官网</el-button>
							</a>
						</div> -->
						<div class="login-bottom">
							<!-- <a href="javascript:;" title="常见问题">常见问题</a> -->
							<!--  <i class="iconfont icon-shuxian"></i>
					    <a href="javascript:;" title="忘记密码">忘记密码?</a> -->
						</div>
					</el-form>
				</div>
			</div>
		</div>
		<Footer />
	</div>
</template>

<script>
	import Footer from '@/components/layout/Footer';
	import {
		initDynamicRouter
	} from '@/router';
	import {
		mapActions
	} from 'vuex';
	import md5 from 'md5';
	import global from 'global';
	import {
		getCode,
		getSendPhoneLoginCode,
	} from '@/serve/user';
	import {
		randomInt
	} from 'crypto';
	const Base64 = require('js-base64').Base64
	let timerID = '';
	// import Footer from '@/components/layout/Footer';
	export default {
		components: {
			Footer
		},
		data() {
			return {
				checked: false,
				passwordType:false,
				tempPwd: '',
				imgUrl: '',
				loading: false,
				disabled: false,
				params: {
					username: '',
					password: '',
					captchaCode: '',
					captchaUuid: '',
					phone:'',
					codeUuid:''
				},
				rules: {
					username: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
					captchaCode: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}],
					phone:[{
						required: true,
						message: '请输入手机号码',
						trigger: 'blur'
					}],
				},
				activeIndex:'1',
				codeTime:0,
			};
		},
		created() {
			this.randomLenNum();
			
		},
		mounted() {
			let username = localStorage.getItem('username')
			if (username) {
				this.params.username = localStorage.getItem('username')
				this.params.password = Base64.decode(localStorage.getItem('password')) // base64解密
				this.checked = true
			}
		},
		methods: {
			async tapGetCode() {
				const phone = this.params.phone;
				if (!/^1[3-9][\d]{9}$/.test(phone)) {
					this.$message.error("手机号格式不正确");
					return;
				}
				if (this.codeTime) {
					return;
				}
				// 发送验证码
				 await getSendPhoneLoginCode(phone).then((res) => {
					this.codeTime = 59;
					timerID = setInterval(() => {
						this.codeTime--;
						!this.codeTime && this.clearTime();
					}, 1000);
					this.loginParams.codeUuid = res.id;
				}).catch((err) => {
					console.log("message",err)
					this.$message.error(err.data.message);
					return;
				});
			},
			clearTime() {
				clearTimeout(timerID);
				timerID = null;
			},
			handleSelect(index){
				this.$refs.login.clearValidate();
				this.activeIndex = index;
			},
			...mapActions({
				login: 'user/login',
				loginPhone:'user/loginPhone',
			}),

			// 随机字符串
			randomLenNum() {
				var chars = [
					'0',
					'1',
					'2',
					'3',
					'4',
					'5',
					'6',
					'7',
					'8',
					'9',
					'A',
					'B',
					'C',
					'D',
					'E',
					'F',
					'G',
					'H',
					'I',
					'J',
					'K',
					'L',
					'M',
					'N',
					'O',
					'P',
					'Q',
					'R',
					'S',
					'T',
					'U',
					'V',
					'W',
					'X',
					'Y',
					'Z',
					'a',
					'b',
					'c',
					'd',
					'e',
					'f',
					'g',
					'h',
					'i',
					'j',
					'k',
					'l',
					'm',
					'n',
					'o',
					'p',
					'q',
					'r',
					's',
					't',
					'u',
					'v',
					'w',
					'x',
					'y',
					'z'
				];
				var nums = '';
				for (var i = 0; i < 32; i++) {
					var id = parseInt(Math.random() * 61);
					nums += chars[id];
				}
				
				this.params.captchaUuid = nums;
				this.getCode(nums);
			},
			// 获取验证码
			getCode(uuid) {
				// this.imgUrl = `https://api.pochanyun.com/api/sys/captcha/img?w=150&h=45&type=SC&uuid=${uuid}`;
				// this.imgUrl = `https://live.pochanyun.net/api/sys/captcha/img?w=150&h=45&type=SC&uuid=${uuid}`;
				this.imgUrl = `/api/sys/captcha/img?w=150&h=45&type=SC&uuid=${uuid}`;
			},
			submitForm() {
				this.$refs.login.validate((valid) => {
					if (valid) {
						if(this.activeIndex == '1'){
							// 账号登录
							if (this.checked) {
								let password = Base64.encode(this.params.password) // base64加密
								localStorage.setItem('username', this.params.username)
								localStorage.setItem('password', password)
							} else {
								localStorage.setItem('username', '')
								localStorage.setItem('password', '')
							}
							this.disabled = this.loading = true;
							this.tempPwd = this.params.password; // 临时保存加密前密码
							this.params.password = md5(this.params.password);
							this.login(this.params)
								.then(() => {
									initDynamicRouter();
									this.$message.success('登录成功');
									window.localStorage.removeItem('synchronizationVote');
									this.$router.replace('/');
								})
								.catch((err) => {
									this.randomLenNum();
									this.params.password = this.tempPwd;
									this.disabled = this.loading = false;
									if (err.status == 400) {
										return this.$message.error(err.data.message);
									}
								});
						}else if(this.activeIndex == '2'){
							// 手机号码登录
							this.loginPhone({
								loginPhone:this.params.phone,
								captchaCode:this.params.captchaCode,
							})
							.then(() => {
									initDynamicRouter();
									this.$message.success('登录成功');
									window.localStorage.removeItem('synchronizationVote');
									this.$router.replace('/');
								})
								.catch((err) => {
									
									this.disabled = this.loading = false;
									if (err.status == 400) {
										return this.$message.error(err.data.message);
									}
								});
						}
						
					}
				});
			}
		}
	};
</script>

<style scoped lang="scss">
	.el-menu-item{
		font-size: 18px;
	}
	.el-menu.el-menu--horizontal{
		border-bottom: 0px;
	}
	::v-deep .el-input--medium .el-input__inner{
		height: 45px;
		font-size: 16px;
		padding-left: 35px;
	}
	::v-deep .el-input--medium{
		font-size: 16px;
	}
	.top_shade {
		width: 100%;
		height: 70px;
		background-image: url(../../assets/img/top_shade.png);
		background-size: 100% 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: fixed;
		top: 0px;
		left: 0px;
		z-index: 999;

		.logo {
			display: flex;
			align-items: center;

			.logo_text {
				padding-left: 20px;
				border-left: 1px solid #FFFFFF;
				font-size: 22px;
				font-family: Source Han Sans CN-Regular, Source Han Sans CN;
				font-weight: 400;
				color: #FFFFFF;
				line-height: 22px;
				text-align: end;
			}
		}

		.logo img {
			width: 120px;
			height: 36px;
			margin-left: 20px;
			margin-right: 20px;

		}

		.official_website {
			display: flex;
			align-items: center;
			margin-right: 30px;

			.wechat-trigger {
				display: inline-flex;
				align-items: center;
				cursor: pointer;
				color: #fff;
				font-size: 20px;
				user-select: none;
			}
			.wechat-icon {
				display: block;
				height: 28px;
				width: auto;
				vertical-align: middle;
			}
		}
	}

	.login-container {
		width: 100%;
		height: 100%;



		.login-wrap ::v-deep .el-form-item--small {
			margin-bottom: 20px;
		}

		.login-wrap ::v-deep .el-form-item__content {
			display: flex;
			// justify-content: center;
			align-items: center;
		}

		.login-wrap_text {
			position: relative;
			top: 35%;
			text-align: center;
			width: 60%;
			z-index: 1;

			.login-wrap_text1 {
				font-size: 48px;
				font-family: PingFang SC Medium-, PingFang SC Medium;
				font-weight: normal;
				color: #FFFFFF;
				line-height: 67px;
				letter-spacing: 10px;
				text-shadow: 0px 3px 12px rgba(0, 0, 0, 0.15);
				margin-bottom: 5px;
			}

			.login-wrap_text2 {
				font-size: 24px;
				font-family: PingFang SC Medium-, PingFang SC Medium;
				font-weight: normal;
				color: #FFFFFF;
				line-height: 34px;
				letter-spacing: 10px;
				text-shadow: 0px 3px 12px rgba(0, 0, 0, 0.15);
			}
		}

		.login-wrap {
			position: relative;
			width: 100%;
			height: 88%;
			background-image: url(../../assets/img/replace-img.jpg);
			background-size: 100%;
			// margin-top: -70px;
			padding-top: 70px;
			// z-index: 1;

			img {
				width: 150px;
				height: 45px;
				cursor: pointer;
			}

			.record {
				position: absolute;
				bottom: 15px;
				left: 50%;
				transform: translateX(-50%);

				a {
					color: #fff;

					&:hover {
						color: #d32627;
						text-decoration: underline;
					}
				}
			}
		}

		.ms-title {
			width: 100%;
			line-height: 50px;
			text-align: center;
			font-size: 20px;
			color: #fff;
			// background: #d32627;

			// background: -webkit-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
			// background: -moz-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
			// background: -o-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
			// background: -ms-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
			// background: linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
			font-weight: bolder;
			border-bottom: 1px solid #ddd;
		}

		.ms-login {
			position: absolute;
			top: 20%;
			right: 15%;
			width: 470px;
			height: 491px;
			border-radius: 5px;
			background: #fff;
			overflow: hidden;
			box-shadow:  0px 12px 45px 0px rgba(0,0,0,0.15);
			z-index: 99;

			.login_text_img img {
				width: 69px;
				height: 50px;
			}

			.ms-login_text {
				font-size: 22px;
				font-family: PingFang SC Medium-, PingFang SC Medium;
				font-weight: normal;
				color: #333333;
				line-height: 31px;
				letter-spacing: 5px;
				margin-top: 5px;
			}
		}

		.ms-content {
			padding: 30px 30px 8px 30px;
		}

		.login-btn {
			text-align: center;
		}

		.login-btn button {
			width: 100%;
			height: 45px;
			// margin-bottom: 10px;
			// background: #d32627;
			border: none;
			// background: -webkit-linear-gradient(top, #cc0001 , #de4d2a, #f17b2e) !important;
			background: #3478F6;
			// background: -webkit-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
			// background: -moz-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
			// background: -o-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
			// background: -ms-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
			// background: linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
		}

		.login-tips {
			font-size: 12px;
			line-height: 30px;
			color: #fff;
		}

		.login-bottom {
			margin-top: 30px;
			font-size: 12px;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.login-bottom a {
			color: #000;

			&:hover {
				text-decoration: underline;
			}
		}
	}
</style>
<style lang="scss">
	/* 微信公众号二维码 popover（挂载到 body，需非 scoped） */
	.wechat-qrcode-popover {
		.wechat-qrcode-wrap {
			text-align: center;
		}
		.wechat-qrcode-img {
			display: block;
			max-width: 200px;
			height: auto;
		}
	}
</style>
